import React from 'react';

function Algeria(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124146)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 0H36V24H18V0Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H18V24H0V0Z"
          fill="#36A400"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.015 6.79468C21.7274 6.79468 23.2921 7.35669 24.4884 8.28451C22.9733 6.58391 20.63 5.49292 18 5.49292C13.4315 5.49292 9.72803 8.78491 9.72803 12.8458C9.72803 16.9067 13.4315 20.1987 18 20.1987C20.63 20.1987 22.9734 19.1076 24.4885 17.407C23.2922 18.3349 21.7274 18.8969 20.015 18.8969C16.2553 18.8969 13.2075 16.1877 13.2075 12.8458C13.2075 9.50385 16.2553 6.79468 20.015 6.79468ZM23.1873 9.54348L21.2721 11.4729L18.5213 10.7992L20.0463 12.9195L18.5213 15.1766L21.4068 14.2533L22.9843 16.442V13.9017L25.562 12.9195L22.9843 12.0987L23.1873 9.54348Z"
          fill="#FF0000"
        />
      </g>
      <defs>
        <clipPath id="clip0_800_124146">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Algeria;
